import { useCrossSellConfigContext } from '../../../cross-sell/components/CrossSellConfigProvider/CrossSellConfigProvider'
import { useCrossSellWidgetContext } from '../../../cross-sell/components/CrosssellWidgetProvider/CrosssellWidgetProvider'
import { CROSS_SELL_LAYOUT_TYPE } from '../../../cross-sell/config/CrossSellWidgetType'
import { useGetExperiment } from '../../hooks'
import { EXPERIMENT_NAME_CTA_BUTTON_ON_ALL_CSW } from '../../model/EXPERIMENT_NAME'
import { experimentAccessorNonDefault } from '../../model/experimentAccessor'

export const useShowExperimentCtaButton = (): boolean => {
  const experimentCtaButtonOnAllCsw = useGetExperiment(
    EXPERIMENT_NAME_CTA_BUTTON_ON_ALL_CSW,
  )
  const { widgets } = useCrossSellConfigContext()
  const { widgetId } = useCrossSellWidgetContext()

  //if the widget is a part of the crosssellDialog component, we don't want to show the button
  if (!widgetId || widgetId === widgets[CROSS_SELL_LAYOUT_TYPE]?.id) {
    return false
  }
  //if the experiment cro-2052 is in variation default, we don't want to show the button
  if (!experimentAccessorNonDefault(experimentCtaButtonOnAllCsw)) {
    return false
  }

  return true
}
